<template>
  <v-card flat style="max-height: 70vh;overflow-y: auto;">
    <v-card-text>
      <v-row>
        <v-col cols="12" md="6">
          <validation-provider
            v-slot="{ errors }"
            class="requiredMark"
            rules="required"
            :vid="`transport-section-${manifest.id}`"
            name="区間"
          >
            <v-select
              v-model="transportSection"
              :disabled="canEdit"
              :error-messages="errors"
              :items="transportSections"
              dense
              hide-details="auto"
              label="区間"
              outlined
              persistent-placeholder
              style="font-size: 100%"
              @change="sectionChangeEvent"
            />
          </validation-provider>

        </v-col>
      </v-row>
    </v-card-text>
    <v-card-text v-if="manifestDraftTransport">
      <!-- 報告担当者／運搬担当者 -->
      <v-row>
        <v-col
          v-if="canEdit"
          cols="12"
          md="6"
        >
          <validation-provider
            v-slot="{ errors }"
            name="報告担当者"
            rules="max:12"
          >
            <v-combobox
              v-model="manifestDraftTransport.report_reporter_name"
              :error-messages="errors"
              :items="users"
              :return-object="false"
              dense
              label="報告担当者"
              hide-details="auto"
              outlined
              persistent-placeholder
            >
              <template v-slot:label>
                <span>報告担当者</span>
                <span class="ml-1">
                  ({{ manifestDraftTransport.report_reporter_name?.length || 0 }} / 12)
                </span>
              </template>
              <template v-slot:counter></template>
            </v-combobox>
          </validation-provider>
        </v-col>
        <v-col
          v-else
          cols="12"
          md="6"
        >
          <validation-provider
            v-slot="{ errors }"
            name="報告担当者"
          >
            <v-text-field
              v-model="manifestDraftTransport.report_reporter_name"
              :error-messages="errors"
              disabled
              dense
              label="報告担当者"
              hide-details="auto"
              outlined
              persistent-placeholder
            >
              <template v-slot:label>
                <span>報告担当者</span>
                <span class="ml-1">
                  ({{ manifestDraftTransport.report_reporter_name?.length || 0 }} / 12)
                </span>
              </template>
              <template v-slot:counter></template>
            </v-text-field>
          </validation-provider>
        </v-col>
        <v-col
          v-if="canEdit"
          cols="12"
          md="6"
        >
          <validation-provider
            v-slot="{ errors }"
            :class="['dxe_form', 'transfer_form'].includes(manifest.manifest_type) ? 'requiredMark' : ''"
            :rules="{ required: ['dxe_form', 'transfer_form'].includes(manifest.manifest_type), max: 12 }"
            name="運搬担当者"
          >
            <v-combobox
              v-model="manifestDraftTransport.report_transport_user_name"
              :error-messages="errors"
              :items="drivers"
              :return-object="false"
              dense
              label="運搬担当者"
              hide-details="auto"
              outlined
              persistent-placeholder
            >
              <template v-slot:label>
                <span>運搬担当者</span>
                <span class="ml-1">
                  ({{ manifestDraftTransport.report_transport_user_name?.length || 0 }} / 12)
                </span>
              </template>
              <template v-slot:counter></template>
            </v-combobox>
          </validation-provider>
        </v-col>
        <v-col
          v-else
          cols="12"
          md="6"
        >
          <validation-provider
            v-slot="{ errors }"
            :class="['dxe_form', 'transfer_form'].includes(manifest.manifest_type) ? 'requiredMark' : ''"
            name="運搬担当者"
          >
            <v-text-field
              v-model="manifestDraftTransport.report_transport_user_name"
              :error-messages="errors"
              disabled
              dense
              label="運搬担当者"
              hide-details="auto"
              outlined
              persistent-placeholder
            >
              <template v-slot:label>
                <span>運搬担当者</span>
                <span class="ml-1">
                  ({{ manifestDraftTransport.report_transport_user_name?.length || 0 }} / 12)
                </span>
              </template>
              <template v-slot:counter></template>
            </v-text-field>
          </validation-provider>
        </v-col>
      </v-row>
      <!-- /報告担当者／運搬担当者 -->

      <!-- 運搬量／運搬量の単位 -->
      <v-row>
        <v-col cols="12" md="6">
          <validation-provider
            v-slot="{ errors }"
            :class="manifestDraftTransport.use_report_transport_quantity || manifestDraftTransport.report_transport_quantity_unit_id > 0 ? 'requiredMark' : ''"
            :rules="{
              required: (manifestDraftTransport.use_report_transport_quantity || manifestDraftTransport.report_transport_quantity_unit_id > 0),
              double: true,
              min_value: 0.001,
              max_value: 99999.999,
              quantityWithDecimal: { int_digits: 5, dec_digits: 3 }
            }"
            :vid="`report_transport_quantity-${manifest.id}`"
            name="運搬量"
            :custom-messages="customMessages"
          >
            <v-text-field
              v-model="manifestDraftTransport.report_transport_quantity"
              :disabled="!canEdit"
              :error-messages="errors"
              dense
              hide-details="auto"
              label="運搬量"
              outlined
              reverse
              persistent-placeholder
              type="number"
              @keydown.69.prevent
            >
            </v-text-field>
          </validation-provider>
        </v-col>
        <v-col cols="12" md="6">
          <validation-provider
            v-slot="{ errors }"
            :class="manifestDraftTransport.use_report_transport_quantity || manifestDraftTransport.report_transport_quantity > 0 ? 'requiredMark' : ''"
            :rules="{
              required: (manifestDraftTransport.use_report_transport_quantity || manifestDraftTransport.report_transport_quantity > 0)
            }"
            :vid="`report_transport_quantity_unit_id-${manifest.id}`"
            name="運搬量の単位"
          >
            <v-select
              v-model="manifestDraftTransport.report_transport_quantity_unit_id"
              :disabled="!canEdit"
              :error-messages="errors"
              :items="quantityUnits"
              clearable
              dense
              hide-details="auto"
              label="運搬量の単位"
              outlined
              persistent-placeholder
              style="font-size: 100%"
            />
          </validation-provider>
        </v-col>
      </v-row>
      <!-- /運搬量／運搬量の単位 -->

      <!-- 有価物収集量／有価物収集量の単位 -->
      <v-row>
        <v-col cols="12" md="6">
          <validation-provider
            v-slot="{ errors }"
            :class="manifestDraftTransport.report_valuables_collecting_quantity_unit_id > 0 ? 'requiredMark' : ''"
            :custom-messages="customMessages"
            :rules="{
              required: manifestDraftTransport.report_valuables_collecting_quantity_unit_id > 0,
              double: true,
              min_value: 0.001,
              max_value: 99999.999,
              quantityWithDecimal: { int_digits: 5, dec_digits: 3 }
            }"
            :vid="`report_valuables_collecting_quantity-${manifest.id}`"
            name="有価物拾集量"
          >
            <v-text-field
              v-model="manifestDraftTransport.report_valuables_collecting_quantity"
              :disabled="!canEdit"
              :error-messages="errors"
              dense
              hide-details="auto"
              label="有価物拾集量"
              outlined
              persistent-placeholder
              reverse
              type="number"
              @keydown.69.prevent
            >
            </v-text-field>
          </validation-provider>
        </v-col>
        <v-col cols="12" md="6">
          <validation-provider
            v-slot="{ errors }"
            :class="valuableCollectingUnitToBe ? 'requiredMark' : ''"
            :rules="{ required: valuableCollectingUnitToBe }"
            name="有価物拾集量の単位"
          >
            <v-select
              v-model="manifestDraftTransport.report_valuables_collecting_quantity_unit_id"
              :disabled="!canEdit"
              :error-messages="errors"
              :items="valuablesQuantityUnits"
              clearable
              dense
              hide-details="auto"
              label="有価物拾集量の単位"
              outlined
              persistent-placeholder
              style="font-size: 100%"
            />
          </validation-provider>
        </v-col>
      </v-row>
      <!-- /有価物収集量／有価物収集量の単位 -->

      <!-- 車両番号／運搬終了日 -->
      <v-row>
        <v-col
          v-if="canEdit"
          cols="12"
          md="6"
        >
          <validation-provider
            v-slot="{ errors }"
            name="車両番号"
            rules="max:15"
          >
            <v-combobox
              v-model="manifestDraftTransport.report_vehicle_number"
              :error-messages="errors"
              :items="vehicles"
              :return-object="false"
              :clearable="true"
              item-text="number"
              item-value="number"
              dense
              label="車両番号"
              hide-details="auto"
              outlined
              persistent-placeholder
            >
              <template v-slot:label>
                <span>車両番号</span>
                <span class="ml-1">
                  ({{ manifestDraftTransport.report_vehicle_number?.length || 0 }} / 15)
                </span>
              </template>
              <template v-slot:counter></template>
            </v-combobox>
          </validation-provider>
        </v-col>
        <v-col
          v-else
          cols="12"
          md="6"
        >
          <validation-provider
            v-slot="{ errors }"
            name="車両番号"
          >
            <v-text-field
              v-model="manifestDraftTransport.report_vehicle_number"
              :error-messages="errors"
              disabled
              dense
              label="車両番号"
              hide-details="auto"
              outlined
              persistent-placeholder
            />
          </validation-provider>
        </v-col>
        <v-col cols="12" md="6">
          <cs-date-picker
            :date.sync="manifestDraftTransport.report_transport_completed_date"
            :disabled="!canEdit"
            :minimum-date="manifestDraft.collected_date ? manifestDraft.collected_date : null"
            :maximum-date="systemDate"
            @dateChangedCallback="(date) => {manifestDraftTransport.report_transport_completed_date = date}"
          >
            <template v-slot="{ on, attrs }">
              <validation-provider
                v-slot="{ errors }"
                class="requiredMark"
                name="運搬終了日"
                rules="required"
              >
                <v-text-field
                  v-model="manifestDraftTransport.report_transport_completed_date"
                  v-bind="attrs"
                  v-on="on"
                  :disabled="!canEdit"
                  :error-messages="errors"
                  append-icon="mdi-calendar"
                  clearable
                  dense
                  hide-details="auto"
                  label="運搬終了日"
                  outlined
                  persistent-hint
                  persistent-placeholder
                  readonly
                />
              </validation-provider>
            </template>
          </cs-date-picker>
        </v-col>
      </v-row>
      <!-- /車両番号／運搬終了 -->

      <!-- 運搬備考 -->
      <v-row>
        <v-col cols="12">
          <validation-provider
            v-slot="{ errors }"
            name="運搬備考"
            rules="max:128"
          >
            <v-text-field
              v-model="manifestDraftTransport.report_note"
              :disabled="!canEdit"
              :error-messages="errors"
              dense
              hide-details="auto"
              label="運搬備考"
              outlined
              persistent-placeholder
            >
              <template v-slot:label>
                <span>運搬備考</span>
                <span class="ml-1">
                  ({{ manifestDraftTransport.report_note?.length || 0 }} / 128)
                </span>
              </template>
              <template v-slot:counter></template>
            </v-text-field>
          </validation-provider>
        </v-col>
      </v-row>
      <!-- /運搬備考 -->
    </v-card-text>
  </v-card>
</template>

<script>
/**
 * @param manifestDraftTransport { Object } マニフェストドラフト運搬詳細
 * @property manifestDraftTransport.report_reporter_name { String } 報告担当者
 * @property manifestDraftTransport.report_transport_user_name { String } 運搬担当者
 * @property manifestDraftTransport.report_transport_quantity { Number } 運搬量
 * @property manifestDraftTransport.report_transport_quantity_unit_id { Number } 運搬量の単位
 *
 */
export default {
  name: 'ModifyManifestTransportReportForm',
  components: {},
  mixins: [],
  props: {
    canEdit: {
      type: Boolean,
      default: () => false,
    },
    manifest: {
      type: Object,
      default: () => {},
    },
    manifestDraft: {
      type: Object,
      default: () => {},
    },
    transportSections: {
      type: Array,
      default: () => null
    },
    manifestDraftTransport: {
      type: Object,
      default: () => {},
    },
    currentDraftTransportId: {
      type: Number,
      default: () => null,
    },
    users: {
      type: Array,
      default: () => [],
    },
    drivers: {
      type: Array,
      default: () => [],
    },
    quantityUnits: {
      type: Array,
      default: () => [],
    },
    valuablesQuantityUnits: {
      type: Array,
      default: () => [],
    },
    vehicles: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      customMessages: {
        double: '数量は半角数字のみ使用できます'
      },
      systemDate: this.$dayjs().format("YYYY-MM-DD"),
      transportSection: this.currentDraftTransportId,
    }
  },
  computed: {
    valuableCollectingUnitToBe () {
      if (this.manifestDraftTransport.report_valuables_collecting_quantity) {
        return this.manifestDraftTransport.report_valuables_collecting_quantity > 0
      }
      return false
    },

  },
  watch: {},
  created() {
  },
  methods: {
    sectionChangeEvent (evt) {
      this.$emit('sectionChangeEvent', evt)
    },
  }
}
</script>
